import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { tap, map, switchMap } from 'rxjs/operators';
import { Operation } from 'fast-json-patch';
import { ConfigurationService } from '../../core/services/ConfigurationService';
import { ConfigurationState } from '../../core/store/reducers';

import { LoadSummaryRequest, LoadSummaryResponse, DownloadSummarySearchRequest } from '../models';

@Injectable()
export class ContractService {
  constructor(private http: HttpClient, private configuration: ConfigurationService) {}

  getContractSummary(request: LoadSummaryRequest): Observable<HttpResponse<LoadSummaryResponse>> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        return this.http.post<LoadSummaryResponse>(`${c.config.apiServer}api/contract/summary`, request, { observe: 'response' });
      })
    );
  }

  downloadRequestForm(orderId: string): Observable<boolean | HttpErrorResponse> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        return this.http.get(`${c.config.apiServer}api/contract/${orderId}`, { responseType: 'blob' }).pipe(
          map(rsp => {
            const fileName = `Contract-${orderId}.pdf`;
            this.saveReport(rsp, fileName);
            return true;
          })
        );
      })
    );
  }

  downloadContractSummaryFile(criteria: DownloadSummarySearchRequest): Observable<boolean | HttpErrorResponse> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        return this.http.post(`${c.config.apiServer}api/contract/summary/file`, criteria, { responseType: 'blob' }).pipe(
          map(rsp => {
            let timeStamp = '';
            if (criteria.fromDate && criteria.toDate) {
              timeStamp = `-${new Date(criteria.fromDate).toISOString()}-${new Date(criteria.toDate).toISOString()}`;
            }
            const fileName = `Contract-Summary${timeStamp}.csv`;
            this.saveReport(rsp, fileName);
            return true;
          })
        );
      })
    );
  }

  private saveReport(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = fileName;
    a.click();
    setTimeout(function () {
      window.URL.revokeObjectURL(url);
    }, 1000);
    a.remove(); // remove the element
  }
}
